




import { defineComponent } from "@vue/composition-api";

/**
 * iconfont 图标
 */
export default defineComponent({
  props: {
    name: {
      type: String,
      default: "",
    },
  },
});
